module.exports = __webpack_public_path__ + "img/PVCOMBANK.a67393d3.svg";